import { request } from "./transport";

export type PublicLearningAction =
  | "page_view"
  | "login_clicked"
  | "simulator_opened"
  | "simulation_edited"
  | "scenario_shared"
  | "strategy_saved";
export function sendPublicLearningEvent(data: {
  event: PublicLearningAction;
  visit_id: string;
  path: string;
  locale: string;
  source: string;
  strategy_id?: string;
}): Promise<void> {
  return request("/public_learning_events", {
    method: "POST",
    body: JSON.stringify(data),
    keepalive: true,
    signal: AbortSignal.timeout(5000),
  });
}
